import classNames from 'classnames'
import { useState } from 'react'
import Slider from 'react-slick'
import { s_blog } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import CenterContainer from '../../../common/CenterContainer'
import BlogCard from '../BlogCard'

const BlogDetailMobileRecommendSection = ({ recommendList }) => {
  const { t } = useTranslation()
  const [activeItemIndex, setActiveItemIndex] = useState<number>(0)

  return (
    <div className={style.outerLayout}>
      <CenterContainer clx="pl-[0px] pr-[0px]">
        <div className={style.innerLayout}>
          <div className={style.title}>{t(s_blog.recommen_post)}</div>
          <div className={classNames('newTheme', style.postSectionWrapper)}>
            <Slider
              className="blog-slider slider w-screen px-[16px]"
              slidesToShow={1}
              infinite={true}
              centerMode={true}
              dots={true}
              lazyLoad={'ondemand'}
              centerPadding="0px"
              afterChange={(index) => setActiveItemIndex(index)}
              customPaging={function (i = Number(activeItemIndex)) {
                return (
                  <div
                    className={`mx-auto mt-10 h-6 rounded-full bg-gray-200 ${
                      i == activeItemIndex ? `w-[12px] bg-gray-800` : 'w-[6px] bg-gray-200'
                    }`}
                    onClick={() => setActiveItemIndex(i)}
                  ></div>
                )
              }}
            >
              {recommendList.map((postItem, i) => {
                return (
                  <BlogCard
                    key={postItem._id}
                    isMobile={true}
                    title={postItem.title}
                    subtitle={postItem.subtitle}
                    thumbnail={postItem.thumbnail}
                    slug={postItem.slug.current}
                    tagLists={postItem.tagList}
                    category={postItem.category}
                    subCategory={postItem.subCategory}
                  />
                )
              })}
            </Slider>
          </div>
        </div>
      </CenterContainer>
    </div>
  )
}

export default BlogDetailMobileRecommendSection

const style = {
  outerLayout: ` bg-gray-50`,
  innerLayout: `mb-[120px] mt-[60px] bg-gray-50`,
  title: `Title1-20Bd mb-[16px] ml-[16px]`,
  postSectionWrapper: `mx-auto flex w-screen `,
}
